var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer" },
    [
      _vm.isLoggedIn
        ? _c("v-btn", { on: { click: _vm.logout } }, [_vm._v("Logout")])
        : _c("p", [
            _vm._v("Tweeter is open source! Check out the "),
            _c("a", { attrs: { href: "https://github.com/Jaimies/Tweeter" } }, [
              _vm._v("repository")
            ]),
            _vm._v(".")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }